const $ = jQuery.noConflict();

'use strict';
const Header = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$domBody: $('body'),
	$domHeader: $('.site-header'),
	classHeaderScroll: 'is-sticky',

	/** @description Initialize */
	init: function() {
		this.headerSticky();
		$(document).on('scroll', this.headerSticky.bind(this));
		$(window).on('load', this.headerSticky.bind(this));
		this.setCartCount();
	},

	headerSticky: function() {
		const scrollTop = $(document).scrollTop();
		this.$domHeader.toggleClass(this.classHeaderScroll, scrollTop > 150);
	},

	setCartCount: function() {
		// get cookie
		const cookieName = 'shopify_cart_sync';
		const cookies = `; ${document.cookie}`;
		const parts = cookies.split(`; ${cookieName}=`);
		const cookieValue = parts.length === 2
			? parts.pop().split(';').shift()
			: null;
		// update icon
		const count = parseInt(cookieValue);
		$('.js-cart-count').text(count).toggle(count > 0);

	},

};

export default Header;
